import script from "./SipExtensionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SipExtensionCard.vue?vue&type=script&setup=true&lang=js"

import "./SipExtensionCard.vue?vue&type=style&index=0&id=24f04223&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f04223"]])

export default __exports__